import PrivateExaminationInstruction from './PrivateExaminationInstruction';

export default PrivateExaminationInstruction;
